import SalesEntry from "./Sales/SalesEntry";
import PurchaseEntry from "./Purchase/PurchaseEntry";
import SalesReturnEntry from "./Sales/SalesReturnEntry";
import PurchaseReturnEntry from "./Purchase/PurchaseReturnEntry";
import Report from "./Report";
export default {
  SalesEntry,
  PurchaseEntry,
  SalesReturnEntry,
  PurchaseReturnEntry,
  Report,
};
